// extracted by mini-css-extract-plugin
module.exports = {"module":"complex-floor-column_module__28SIp","floor":"complex-floor-column_floor__1cZPH"};